import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {ApiInsights} from './ApiInsights'

registerReactPartial('internal-api-insights', {
  Component: ApiInsights,
})
